import React, { useEffect, useRef, useState } from 'react';
import { Carousel } from 'antd';
import './ImageCarousel.css'; // Import the CSS file
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import styled from 'styled-components';


interface ImageCarouselProps {
  images: string[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ images }) => {
  const carouselRef = useRef<any>(null);

  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    //Handle Responsiveness  
    const handleResize = () => {
      setWidth(window.innerWidth)
    }

    handleResize()

    // Bind the event listener
    window.addEventListener('resize', handleResize)

    return () => {
      // Unbind the event listener on clean up
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const handlePrev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

const StyledCarousel = styled(Carousel)`
  @media only screen and (max-width: 600px) {
    .slick-slide.slick-active.slick-current {
      width: 27rem !important; 
      margin-right: 2rem !important;
    }
  }
`;

  return (
    <div className="image-carousel-container">
      <div className="blur-background">
        <StyledCarousel
          ref={carouselRef}
          className='carousel'
          dots={false}
        >
          {images.map((imageUrl, index) => (
            <div key={index}>
              <img
                className="carouselImage"
                src={imageUrl}
                alt={`Slide ${index + 1}`}
              />
            </div>
          ))}
        </StyledCarousel>
      </div>

      {/* {width > 1200 &&  */}
        <div className="arrowContainer">
          <div
            className="custom-arrow"
            onClick={handlePrev}
          >
            <FaChevronLeft style={{marginLeft: `${width > 1200 ? '-3rem' : '-1rem'}`}} /> 
          </div>
          <div
            className="custom-arrow"
            onClick={handleNext}
          >
            <FaChevronRight style={{marginRight: `${width > 1200 ? '-3rem' : '-1rem'}`}} />
          </div>
        </div>
      {/* } */}
    </div>
  );
};

export default ImageCarousel;
